export const downloadResources = [
  {
    slug: "bai-tu-danh-gia",

    en: {
      title: "Self-Assessment Workbook",
      description:
        "Explore your strengths, values, interests and career direction through a practical self-assessment.",
      category: "Career clarity",
    },

    vi: {
      title: "Bài Tự Đánh Giá",
      description:
        "Khám phá điểm mạnh, giá trị, sở thích và định hướng nghề nghiệp phù hợp với bạn.",
      category: "Định hướng nghề nghiệp",
    },
  },

  {
    slug: "banh-xe-cuoc-song",

    en: {
      title: "Wheel of Life",
      description:
        "Review the balance between your career, relationships, wellbeing, finances and personal life.",
      category: "Life planning",
    },

    vi: {
      title: "Bánh Xe Cuộc Sống",
      description:
        "Đánh giá mức độ cân bằng giữa sự nghiệp, các mối quan hệ, sức khỏe, tài chính và cuộc sống.",
      category: "Lập kế hoạch cuộc sống",
    },
  },
];

export const resourceText = {
  en: {
    eyebrow: "Free career resources",
    heroTitle: "Resources for your career journey",
    heroDescription:
      "Practical tools to help you understand yourself, clarify your direction and take your next career step with confidence.",

    home: "Home",
    resources: "Free Resources",

    sectionEyebrow: "Explore the collection",
    sectionTitle: "Choose a resource to begin",
    sectionDescription:
      "Select a workbook and enter your email. Your download will begin immediately, and a copy of the link will be sent to your inbox.",

    pdfLabel: "Free PDF workbook",
    downloadButton: "Download PDF",

    modalEyebrow: "Free PDF resource",
    modalTitle: "Download your workbook",
    modalDescription: "Enter your email address to receive and download:",

    emailLabel: "Email address",
    emailPlaceholder: "you@example.com",

    consent:
      "I would like to receive career guidance, practical resources and updates from TB Career Coaching.",

    privacy:
      "Your email is secure and will only be used according to your selected preference.",

    submitButton: "Email and download PDF",
    preparing: "Preparing your download...",

    validEmail: "Please enter a valid email address.",
    sentMessage: "Your download link has been sent to your email.",
    failedMessage: "Unable to prepare your download. Please try again.",

    featureOne: "Practical exercises",
    featureTwo: "Clear reflection prompts",
    featureThree: "Download immediately",

    close: "Close",
  },

  vi: {
    eyebrow: "Tài liệu nghề nghiệp miễn phí",
    heroTitle: "Tài liệu đồng hành cùng hành trình nghề nghiệp",
    heroDescription:
      "Những công cụ thực tế giúp bạn hiểu bản thân, xác định hướng đi và tự tin thực hiện bước tiếp theo trong sự nghiệp.",

    home: "Trang chủ",
    resources: "Tài liệu miễn phí",

    sectionEyebrow: "Khám phá tài liệu",
    sectionTitle: "Chọn tài liệu để bắt đầu",
    sectionDescription:
      "Chọn tài liệu và nhập email. Tài liệu sẽ được tải xuống ngay, đồng thời liên kết tải cũng được gửi đến hộp thư của bạn.",

    pdfLabel: "Tài liệu PDF miễn phí",
    downloadButton: "Tải tài liệu",

    modalEyebrow: "Tài liệu PDF miễn phí",
    modalTitle: "Nhận tài liệu của bạn",
    modalDescription: "Nhập địa chỉ email để nhận và tải tài liệu:",

    emailLabel: "Địa chỉ email",
    emailPlaceholder: "email@example.com",

    consent:
      "Tôi muốn nhận thêm hướng dẫn nghề nghiệp, tài liệu thực tế và thông tin mới từ TB Career Coaching.",

    privacy:
      "Email của bạn được bảo mật và chỉ được sử dụng theo lựa chọn của bạn.",

    submitButton: "Gửi email và tải PDF",
    preparing: "Đang chuẩn bị tài liệu...",

    validEmail: "Vui lòng nhập địa chỉ email hợp lệ.",
    sentMessage: "Liên kết tải tài liệu đã được gửi đến email của bạn.",
    failedMessage: "Không thể chuẩn bị tài liệu. Vui lòng thử lại.",

    featureOne: "Bài tập thực tế",
    featureTwo: "Câu hỏi định hướng rõ ràng",
    featureThree: "Tải xuống ngay",

    close: "Đóng",
  },
};
